import {Typography} from "@mui/material";
import {Outlet} from "react-router-dom";


const ContactsRoute = () => {
    return (
        <Outlet/>
    )
}

export default ContactsRoute;